export default {
  skip_to_main_content: 'Ana içeriğe geç',
  show_system_messages: 'Sistem mesajlarını göster',
  dont_show_system_messages: 'Sistem mesajlarını gizle',
  logged_in: 'Kiracının kimliği doğrulandı',
  logged_out: 'Anonim kullanıcı',
  button_tooltip_switch_locale: 'Yerel ayarı değiştir',
  button_tooltip_activate_voice_recognition: 'Ses tanımayı etkinleştir',
  date_input: 'Tarih seçin',
  choose_two_dates: 'Lütfen iki tarih seçin',
  date_range: 'Tarih aralığı',
  from: 'itibaren',
  to: 'için',
  avatar: 'Avatar',
  exit: 'Çıkış',
  new: 'Yeni',
  back: 'Geri',
  address: 'Adres',
  suggestions: 'Öneriler',
  senton: 'Gönderildi',
  message_placeholder: 'Mesajınızı buraya girin...',
  message_aria: 'Mesajınızı buraya girin',
  upload_in_progress: 'Yükleme devam ediyor...',
  comment_placeholder: 'Yorumunuzu buraya girin',
  message_button_label: 'Gönder',
  please_confirm: 'Lütfen onaylayın',
  no: 'Hayır',
  yes: 'Evet',
  modal_delete_session: 'Oturumu sil',
  modal_delete_session_notification:
    'Pencereyi kapatırsanız, oturumunuz da silinecektir.<br>Bununla bir sorununuz var mı?',
  template_contact_time: 'Sizinle ne zaman iletişime geçebiliriz?',
  template_pause:
    'Oturumunuz duraklatıldı. Destek personelimizden biri kısa süre içinde talebinizle ilgilenecektir',
  template_continue_after_pause:
    'Oturumunuz devam etti. Artık sohbet robotumuzla yazmaya devam edebilirsiniz.',
  choose_date: 'Lütfen bir tarih seçin',
  button_apply: 'Uygula',
  button_cancel: 'İptal',
  none: 'Hiçbiri',
  book_appointment: 'Randevu Al',
  address_input: 'Adres girişi',
  data_processing: 'Veri işleme',
  privacy_policy: 'gizlilik politikası',
  data_processing_notification_before_link:
    'Bu sohbet hizmetini kullanmak için ',
  data_processing_notification_after_link: '.',
  button_accept: 'Kabul Et',
  select_date: 'Tarih Seç',
  rate_conversation: 'Bu görüşmeyi nasıl değerlendirirsiniz?',
  new_ticket_question: 'Size yardımcı olabileceğim başka bir şey var mı?',
  thank_you:
    'Desteğiniz için teşekkür ederim. Geri bildirimleriniz kendimi sürekli geliştirmeme yardımcı oluyor',
  goodbye: 'Güle güle',
  start_new: 'Yeni konuşma başlat',
  operator_entered_the_chat: 'Operatör sohbete girdi',
  operator_left_the_chat: 'Operatör sohbetten ayrıldı',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'Daha fazla',
  collapse_quickreplies: 'Daha az',
  login: 'Giriş yap',
  logout: 'Oturumu kapat',
  close: 'Kapat',
  messenger_text:
    'Bir sorunuz mu var? Size yardımcı olmaktan mutluluk duyarız!',
  chat_bot: 'Sohbet Botu',
  live_bot: 'Canlı Sohbet',
  maximize: 'Maksimize et',
  minimize: 'Küçült',
  upload_file: 'Yüklemek için dosyayı buraya bırakın',
  upload_file_or: 'veya',
  Upload_file_select: 'Dosya ekle',
  upload_file_text: 'Yüklemek için dosyayı bırakın',
  show_attachments: 'Ekleri göster',
  hide_attachments: 'Ekleri gizle',
  tooBig: 'Dosya çok büyük',
  tooSmall: 'Dosya çok küçük',
  invalidFileTypeCopilot:
    'Geçersiz dosya türü. Şu anda yalnızca .png, .jpg, .jpeg, .gif dosya türleri desteklenmektedir.',
  tooManyFiles: 'Lütfen aynı anda en fazla 10 dosya yükleyin',
  uploadError: 'Yükleme başarısız oldu. Lütfen tekrar deneyin.',
  maxDocumentsReached: 'Bu konuşma için maksimum belge sayısına (10) ulaşıldı',
  chatProtocol: 'Sohbet Protokolü',
  showMore: 'Daha fazla göster',
  showLess: 'Daha az göster',
  uploadTooltip: 'Dosya yükle',
  uploadFilesTooltip: 'Dosya yükleme',
  pdfDownloadTooltip: 'Konuşmayı İndir',
  feedbackDescription: 'Öneriniz var mı',
  feedbackPlaceholder: 'Mesajınızı buraya girin...',
  feedbackInfoPlaceholder: 'Belirli ayrıntıları eklemekten çekinmeyin...',
  feedbackSubtitle: {
    description:
      'Buradan bize genel önerilerinizi, tekliflerinizi ve taleplerinizi gönderebilirsiniz.',
    note: 'Lütfen bunlara yanıt veremeyeceğimizi unutmayın.',
    hint:
      'Özellikle kiracılığınızla veya daire arayışınızla ilgili diğer tüm endişelerinizi bize sohbet sırasında anlatabilirsiniz.'
  },
  sendFeedback: 'Gönder',
  giveFeedback: 'Öneriniz var mı',
  feedbackSubmittedSuccessfully: 'Geri bildiriminiz başarıyla gönderildi',
  character_limit: 'Karakter',
  page: 's.',
  factually_incorrect: 'Faktik olarak doğru değil',
  not_following_instructions: 'Tam olarak talimatları takip etmedi',
  info_not_in_document: 'Belgede aranan bilgi bulunamadı',
  inappropriate_or_offensive: 'Uygunsuz veya saldırgan',
  irrelevant: 'İlgisiz',
  not_fitting_topic: 'Konuya uymayan',
  confusing_information: 'Kafa karıştırıcı bilgi',
  ignored_important_parts_of_document:
    'Belgenin önemli bölümleri görmezden gelindi',
  interpreted_document_wrong: 'Belge yanlış yorumlandı',
  answer_to_generic: 'Genel cevap',
  sources_incorrect: 'Kaynaklar güvenilir değil veya yanlış alıntılanmış',
  why_not_helpful: 'Neden yardımcı olmadı?',
  thank_you_feedback: 'Geri bildiriminiz için teşekkürler!',
  provide_feedback: 'Cevap hakkında geri bildirim verin',
  not_helpful: 'Yardımcı değil',
  helpful: 'Yardımcı',
  regenerate_message: 'Yeniden oluştur',
  copy_message: 'Kopyala',
  copied_message: 'Kopyalandı!',
  copy_table_csv: 'Tabloyu kopyala',
  download_table_csv: 'CSV indir',
  expand_table: 'Tabloyu aç',
  print: 'Yazdır',
  original_answer: 'Orijinal cevap',
  regenerated_answer: 'Yeniden oluşturulan cevap',
  thinking_message: 'Düşünüyorum...',
  file_path: 'Dosya yolu: ',
  new_messages: 'Yeni mesajlar',
  previous_message: 'Önceki mesaj',
  next_message: 'Sonraki mesaj',
  clear_input: 'Girişi temizle',
  open_feedback: 'Geri bildirimi aç',
  file_upload: 'Dosya yükleme',
  expand_quickreplies_aria: 'Daha fazla düğme göster',
  button_tooltip_switch_locale_german: 'Dili Almanca olarak değiştir',
  button_tooltip_switch_locale_french: 'Dili Fransızca olarak değiştir',
  button_tooltip_switch_locale_dutch: 'Dili Hollandaca olarak değiştir',
  button_tooltip_switch_locale_turkish: 'Dili Türkçe olarak değiştir',
  button_tooltip_switch_locale_russian: 'Dili Rusça olarak değiştir',
  button_tooltip_switch_locale_swedish: 'Dili İsveççe olarak değiştir',
  button_tooltip_switch_locale_ukranian: 'Dili Ukraynaca olarak değiştir',
  button_tooltip_switch_locale_spanish: 'Dili İspanyolca olarak değiştir',
  button_tooltip_switch_locale_polish: 'Dili Lehçe olarak değiştir',
  button_tooltip_switch_locale_arabic: 'Dili Arapça olarak değiştir',
  button_tooltip_switch_locale_italian: 'Dili İtalyanca olarak değiştir',
  button_tooltip_switch_locale_english: 'Dili İngilizce olarak değiştir',
  message_from_you: 'Sen diyorsun',
  message_from_bot: 'Bot diyor',
  message_from_operator: 'Ajan diyor',
  new_message_from_bot: 'Bot diyor',
  empty_message_received: 'Boş mesaj alındı',
  open_quick_actions: 'Hızlı eylemleri aç',
  quick_actions: 'Hızlı eylemler',
  quick_actions_search_hint: '...veya öneriler için yazmaya devam edin',
  quick_actions_no_results: 'Sonuç bulunamadı'
}
